import $ from "jquery";
import _ from "underscore";
import Backbone from "backbone";
import XolaBackboneSDK from "../Xola";
import Scheduler from "node-schedule";
import moment from "moment-timezone";
import { Config } from "../application/Config";
import { Debug } from "../application/Debug";

/**
 * Generates an EventCollection out of the availability endpoint
 */
export const UpcomingEvents = XolaBackboneSDK.Collection.Events.extend({
    initialize(models = null, options = {}) {
        XolaBackboneSDK.Collection.Events.prototype.initialize.apply(this, arguments);

        this.listenTo(this, 'add', this.onAdd);
        this.listenTo(this, 'remove', this.onRemove);
    },

    onAdd(event) {
        var date = this.getHideTime(event.attributes).toDate();
        event.job = Scheduler.scheduleJob(date, () => {
            this.remove(event);
        });

        if (Config.display.get("config").events.showDemographics) {
            var orders = event.get("orders");
            if (orders) {
                this.fetchOrders(event, {added: orders.models});
                this.listenTo(orders, "update", (orders, options) => {
                    this.fetchOrders(event, options.changes);
                });
            }
        }
    },

    onRemove(event) {
        if (event.job) {
            event.job.cancel();
            event.job = null;
        }
    },

    fetchOrders(event, orders) {
        if (orders.added.length) {
            Debug.log("UpcomingEvents.fetchOrders():", orders);

            var preloadData = [];

            _.each(orders.added, (order) => {
                if (!order.has("createdAt")) {
                    preloadData.push(order.fetch());
                }
            });

            Backbone.$.when.apply(Backbone.$, preloadData).then(() => {
                Debug.log("UpcomingEvents.fetchOrders():", "Fetching orders complete.");
                event.trigger("demographics.sync");
            });
        }
        else {
            Debug.log("UpcomingEvents.fetchOrders():", "Nothing to fetch.");
        }

        event.trigger("demographics.sync");
    },

    fetchDaysEvents(data) {
        var now = moment.tz(Config.timezone);
        var startTime = now.clone().startOf("day");
        var endTime;
        if (Config.display.get("config").events.showTomorrowsEvents) {
            endTime = now.clone().add(1, "day").endOf("day");
        }
        else {
            endTime = now.clone().endOf("day");
        }

        _.extend(data.data, {
            start: startTime.format('X'),
            end: endTime.format('X')
        });

        return this.fetch(data);
    },

    parse(response) {
        var events = [];

        var now = moment.tz(Config.timezone);
        var experienceCollection = XolaBackboneSDK.CollectionPool.getCollection(XolaBackboneSDK.Collection.Experiences);
        var guideCollection = Config.seller.getGuides();

        $.each(response, (index, event) => {
            var experience = experienceCollection.get(event.experience.id);
            if (!experience) {
                return;
            }

            if (event.guides && event.guides.length) {
                $.each(event.guides, (index, guide) => {
                    event.guides[index] = guideCollection.findByUser(guide);
                });
            }

            event.start = moment.tz(event.start, "UTC");
            event.actualStart = moment.tz(event.actualStart, "UTC");
            // event.max = experience.get("group") ? experience.get("group").outingMax : null;

            if (event.start.format('HHmm') != "0000" && this.getHideTime(event).isAfter(now)) {
                if (Config.display.get("config").events.capacity == "reserved") {
                    if (event.quantity.reserved > 0) {
                        events.push(event);
                    }
                }
                else {
                    events.push(event);
                }
            }
        });

        return events;
    },

    findByExperienceAndTime(experience, date, time) {
        return this.find((event) => {
            return event.get("experience").id == experience.id
                && event.get("start").format("YYYY-MM-DD") == date
                && event.get("start").format("Hmm") == time;
        });
    },

    /**
     * Sort events based on ascending order of their start time. Earlier events go at the top, with all-day events
     * being pushed to the bottom
     *
     * @returns {number}
     */
    comparator(model1, model2) {
        if (!model1.get('start') || !model2.get('start')) {
            return 1;
        }

        return model1.get('start').isAfter(model2.get('start')) ? 1 : -1;
    },

    getHideTime(event) {
        var startTime = event.actualStart ? event.actualStart : event.start;
        var hideTime = startTime.clone();

        switch (Config.display.get("config").events.hideTimeout) {
            case "dayEnd":
                hideTime.endOf("day");
                break;

            case "eventEnd":
                var experienceCollection = XolaBackboneSDK.CollectionPool.getCollection(XolaBackboneSDK.Collection.Experiences);
                var experience = experienceCollection.get(event.experience.id);
                var duration = experience.get('eventDuration');
                if (duration == null) {
                    duration = experience.get('duration');
                }
                hideTime.add(duration, "minutes");
                break;

            default:
                hideTime.add(Config.display.get("config").events.hideTimeout, "minutes");
        }

        event.hideTime = hideTime;

        return hideTime;
    }
});



// WEBPACK FOOTER //
// ./src/js/collections/UpcomingEvents.js